import { render } from "./tujuanSasaran.vue?vue&type=template&id=7e5ca87e"
import script from "./tujuanSasaran.vue?vue&type=script&lang=js"
export * from "./tujuanSasaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__